import type {
  BackgroundJobDetail,
  BackgroundJobFilters,
  BackgroundJobsCount,
  BackgroundJobsCountBody,
  BackgroundJobsListBody,
  BackgroundJobsListResponse,
} from '@/api/(admin)/background-jobs/types';
import { BACKEND_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';

/**
 * Background job runs. Registered under `/system` on the backend, guarded by
 * `isAdmin` and served from the same host as the other management endpoints,
 * so the base is passed explicitly — otherwise the request goes to the
 * api-service and 404s.
 */

/** One page of handler runs. A POST because the filters travel in the body. */
export async function fetchBackgroundJobs(
  body: BackgroundJobsListBody,
): Promise<BackgroundJobsListResponse> {
  return apiFetch<BackgroundJobsListResponse>(
    '/system/queue-jobs/list',
    { method: 'POST', body: JSON.stringify(body) },
    BACKEND_URL,
  );
}

/** How many runs match the filters, capped. */
export async function fetchBackgroundJobsCount(
  body: BackgroundJobsCountBody,
): Promise<{ data: BackgroundJobsCount }> {
  return apiFetch<{ data: BackgroundJobsCount }>(
    '/system/queue-jobs/count',
    { method: 'POST', body: JSON.stringify(body) },
    BACKEND_URL,
  );
}

/** One run in full. */
export async function fetchBackgroundJob(
  id: string,
): Promise<{ data: BackgroundJobDetail }> {
  return apiFetch<{ data: BackgroundJobDetail }>(
    `/system/queue-jobs/${id}`,
    {},
    BACKEND_URL,
  );
}

/** Registered job names and handlers, for the filter dropdowns. */
export async function fetchBackgroundJobFilters(): Promise<{
  data: BackgroundJobFilters;
}> {
  return apiFetch<{ data: BackgroundJobFilters }>(
    '/system/queue-jobs/filters',
    {},
    BACKEND_URL,
  );
}
